///Graphview CARD and LINEGRAPH

import React, { useContext, useEffect } from "react";
import * as echarts from "echarts";
import { FilterContext } from "../../context/Filter";



const LineChart = ({ chartId, months, percentages }) => {

  const { open } = useContext(FilterContext);
  useEffect(() => {
    const chartDom = document.getElementById(chartId);
    const myChart = echarts.init(chartDom);

    // Get max percentage value, fallback to 100 if percentages is empty
    const maxPercentage = percentages.length > 0 ? Math.max(...percentages) : 100;

    const option = {
      grid: {
        left: "8%",
        right: "10%",
        bottom: "25%",
        top: "25%",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          return `${params[0].name}: ${params[0].value}%`;
        },
      },
      xAxis: {
        type: "category",
        data: months,
        axisLabel: {
          rotate: 50,
          fontSize: 8,
          fontWeight: "semiBold",
          interval: 0,
        },
        axisTick: {
          alignWithLabel: true,
        },
        axisLine: {
          lineStyle: {
            color: "#333",
            width: 1,
          },
        },
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: Math.ceil(maxPercentage), // Set max dynamically based on data
        interval: Math.ceil(maxPercentage / 5), // Divide into 5 equal intervals
        padding: [0, 0, 5, 5],
        axisLabel: {
          formatter: "{value}%",
          fontWeight: "bold",
          fontSize: 8,
        },
        axisLine: {
          lineStyle: {
            color: "#333",
            width: 1,
          },
        },
        splitLine: {
          show: false,
        },
      },
      series: [
        {
          data: percentages,
          type: "line",
          symbol: "circle",
          symbolSize: 6,
          lineStyle: {
            color: "#333",
            width: 2,
          },
          itemStyle: {
            color: "#333",
          },
          label: {
            show: true,
            position: "top",
            formatter: "{c}%",
            fontSize: 8,
            fontWeight: "bold",
            color: "#333",
          },
        },
      ],
    };

    myChart.setOption(option);

    window.addEventListener("resize", () => {
      myChart.resize();
    });

    return () => {
      window.removeEventListener("resize", () => {
        myChart.resize();
      });
      myChart.dispose();
    };
  }, [months, percentages, chartId]);

  return (
    <div id={chartId} className={`h-[250px] ${open ? 'ml-9' : ''} justify-center justify-items-center  ${open ? 'w-[300px]' : 'w-[400px]'}`}></div>
  );
};


const Card = ({
  chartId,
  months,
  percentages,
  title,
  heading,
  yAxisConfig,
  performance,

}) => {
  const { open } = useContext(FilterContext);
  return (
    <div className={`rounded-lg  p-1  w-full min-w-full justify-center justify-items-center shadow-lg bg-white h-[16rem] border`}>
      <h3
        className="text-[12px] text-red font-bold flex justify-center"
        style={{ color: "#000000" }}
      >
        {heading}
      </h3>

      <LineChart
        chartId={chartId}
        months={months}
        percentages={percentages}
        yAxisConfig={yAxisConfig}
      />
    </div>
  );
};

export default Card;
